import { render, staticRenderFns } from "./premiumId.vue?vue&type=template&id=568beac0&scoped=true"
import script from "./premiumId.vue?vue&type=script&lang=js"
export * from "./premiumId.vue?vue&type=script&lang=js"
import style0 from "./premiumId.vue?vue&type=style&index=0&id=568beac0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568beac0",
  null
  
)

export default component.exports